export default __webpack_public_path__ + "static/media/twitter-logo.e08087e7.svg";